module.exports = __webpack_public_path__ + "static/media/img_skill_validation.f34ecfe0.png";